import { Link } from "react-router-dom";

const Sidebar = ({ setSidebarOpen }) => {
  return (
    <div id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link
            className="nav-link"
            to="/dashboard"
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-grid"></i>
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-toggle="collapse"
            href="#subsidy-dep-dropdown"
          >
            <i className="bi bi-menu-button-wide"></i>
            <span>Subsidy Department</span>
            {/* <i className="bi bi-chevron-down ms-auto"></i> */}
          </a>
          <div className="collapse" id="subsidy-dep-dropdown">
            <ul className="nav-content">
              {/* <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  data-bs-toggle="collapse"
                  href="#client-dropdown"
                >
                  <i className="bi bi-chevron-down"></i>
                  <span>Client</span>
                </a>
                <div className="collapse" id="client-dropdown">
                  <ul className="nav-content">
                    <li>
                      <Link to="/client" className="subIcon"
                        onClick={(e) => {
                          localStorage.setItem('activeStep', 2);
                          handleStepChange(2);
                        }}
                      >
                        <i className="bi bi-circle-fill"></i>
                        <span>Client Master</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/edit-client" className="subIcon"
                         onClick={(e) => {
                          localStorage.setItem('activeStep',2);
                          handleStepChange(2);
                        }}
                      >
                        <i className="bi bi-circle-fill"></i>
                        <span>Edit Client</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li> */}
              {/* <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  data-bs-toggle="collapse"
                  href="#project-dropdown"
                >
                  <i className="bi bi-chevron-down"></i>
                  <span>Project</span>
                </a>
                <div className="collapse" id="project-dropdown">
                  <ul className="nav-content">
                    <li>
                      <Link to="/add-project" className="subIcon"
                        onClick={(e) => {
                          localStorage.setItem('activeStep',4);
                          handleStepChange(4);
                        }}
                      >
                        <i className="bi bi-circle-fill"></i>
                        <span>Add Project</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/edit-project" className="subIcon"
                        onClick={(e) => {
                          localStorage.setItem('activeStep',4);
                          handleStepChange(4);
                        }}
                      >
                        <i className="bi bi-circle-fill"></i>
                        <span>Edit Project</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li> */}
            </ul>
          </div>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link"
            to="/manage-key-person"
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-grid"></i>
            <span>Manage Key Person</span>
          </Link>
        </li>

        {/* <li className="nav-item">
          <Link className="nav-link" to='/manage-client' onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-grid"></i>
            <span>Manage Client Master</span>
          </Link>
        </li> */}

        {/* <li className="nav-item">
          <Link className="nav-link" to='/manage-client' onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-grid"></i>
            <span>Manage Client Master</span>
          </Link>
        </li> */}
        <li className="nav-item">
          <Link
            className="nav-link"
            to="/manage-project"
            onClick={() => {
              localStorage?.removeItem("physicalId");
              localStorage.removeItem("projectId");
              localStorage.removeItem("clientId");
              localStorage.removeItem("OwnerId");
              localStorage.removeItem("documentId");
              setSidebarOpen(false);
            }}
          >
            <i className="bi bi-grid"></i>
            <span>Manage Project</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
